import React from 'react';
import { Box, Link } from '@chakra-ui/react';

interface NavItemProps {
  label: string;
  href: string;
  dropdownKey: 'top-features' | 'learn-more';
  isActive: boolean;
  onMouseEnter: (dropdown: 'top-features' | 'learn-more', position: { top: number; left: number }) => void;
  onMouseLeave: () => void;
}

const NavItem: React.FC<NavItemProps> = ({ label, href, dropdownKey, isActive, onMouseEnter, onMouseLeave }) => {
  const navRef = React.useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (navRef.current) {
      const rect = navRef.current.getBoundingClientRect();
      onMouseEnter(dropdownKey, {
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2,
      });
    }
  };

  return (
    <Box
      ref={navRef}
      position="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Link
        href={href}
        style={{ fontFamily: 'lato', fontWeight: 'bold' }}
        color="#13131B"
        _hover={{ textDecoration: 'none' }}
        display="flex"
        alignItems="center"
        gap={1}
        aria-haspopup="true"
        aria-expanded={isActive}
      >
        {label}
        <Box
          as="span"
          transition="transform 0.15s ease"
          transform={isActive ? 'rotate(180deg)' : 'rotate(0deg)'}
          fontSize="0.6em"
          aria-hidden="true"
        >
          ▼
        </Box>
      </Link>
    </Box>
  );
};

export default NavItem;
